import { Link, useParams } from "react-router-dom";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/frontend/components/ui/sidebar";
import { QuerygenMark } from "@/frontend/components/QuerygenMark";

export function AppBranding() {
  const { orgId } = useParams();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          size="lg"
          className="group-data-[state=collapsed]:p-0! group-data-[state=collapsed]:justify-center group-data-[state=collapsed]:h-12"
        >
          <Link to={`/org/${orgId}/app/dashboard`}>
            <QuerygenMark />
            <div className="grid flex-1 text-left text-sm leading-tight group-data-[state=collapsed]:hidden">
              <span className="truncate text-[21px] font-semibold tracking-[-0.03em] font-heading text-[#15221b] dark:text-gray-100">
                Querygen
              </span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
